import { render, staticRenderFns } from "./ParentAcct.vue?vue&type=template&id=3c06e9cc&"
import script from "./ParentAcct.vue?vue&type=script&lang=js&"
export * from "./ParentAcct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports